<template>

<div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
    <div id="loading">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
    </div>
    <!-- <div style="display:none;" id="campaignResults"> -->
    <div  id="campaignResults" style="display: none;">

        <div class="row">
            <h1 class="page-header" id="page-title">Results for campaign.name</h1>
        </div>

        <div :style="[ this.user.role == 'Reader' ? { display: 'none' } : null ]">
            <div class="row">
                <a href="/campaigns" class="btn btn-default">
                    <i class="fa fa-arrow-circle-o-left fa-lg"></i> Back
                </a>
                <template v-if="this.user.role != 'Reader'">
                    <div class="btn-group">
                        <button type="button" id="exportButton" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="true">
                            <i class="fa fa-file-excel-o"></i> Export CSV
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="exportButton">
                            <li>
                                <a href="#" onclick="exportAsCSV('results')">Results</a>
                            </li>
                            <li>
                                <a href="#" onclick="exportAsCSV('events')">Raw Events</a>
                            </li>
                        </ul>
                    </div>
                    <button id="complete_button" type="button" class="btn btn-blue" data-toggle="tooltip" onclick="completeCampaign()">
                        <i class="fa fa-flag-checkered"></i> Complete
                    </button>
                    <button type="button" class="btn btn-danger" data-toggle="tooltip" onclick="deleteCampaign()">
                        <i class="fa fa-trash-o fa-lg"></i> Delete
                    </button>
                </template>
                <button id="refresh_btn" type="button" class="btn btn-blue" data-toggle="tooltip" onclick="refresh()">
                    <i class="fa fa-refresh fa-lg"></i> Refresh
                </button>
                <span id="refresh_message">
                    <i class="fa fa-spin fa-spinner"></i> Refreshing
                </span>
            </div>
            <br />
            <div class="row"> <!--  v-if="this.user.role != 'Reader'" -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div id="timeline_chart"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div style="height:200px;" class="col-lg-1 col-md-1"></div>
                        <div id="sent_chart" style="height:200px;" class="col-lg-2 col-md-2"></div>
                        <div id="opened_chart" style="height:200px;display:none;" class="col-lg-2 col-md-2"></div>
                        <div id="clicked_chart" style="height:200px;" class="col-lg-2 col-md-2"></div>
                        <div id="submitted_data_chart" style="height:200px;" class="col-lg-2 col-md-2"></div>
                        <div id="reported_chart" style="height:200px;" class="col-lg-2 col-md-2"></div>
                        <div style="height:200px;" class="col-lg-1 col-md-1"></div>
                    </div>
                    <div class="row" id="resultsMapContainer">
                        <div class="col-md-6">
                            <p style="text-align:center;">Targets Map</p>
                            <div id="resultsMap"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- blocco da nascondere a utente Reader -->

        <div class="row">
            <div class="container-general-stats">
                <div class="stats-title">Global stats</div>
                <div class="stat-box blue">
                    <img src="../assets/images/stats/target.png" alt="Email target icon">
                    <div>
                        <div class="stat-percentage" id="generalStats_totalTarget">-</div>
                        <div class="stat-description">Email target</div>
                    </div>
                </div>
                <div class="stat-box green">
                    <img src="../assets/images/stats/phishing.png" alt="Phishing email icon">
                    <div>
                        <div class="stat-percentage" id="generalStats_emailSent">-</div>
                        <div class="stat-description">Phishing email sent</div>
                    </div>
                </div>
                <div class="stat-box red">
                    <img src="../assets/images/stats/clicked.png" alt="Mail click icon">
                    <div>
                        <div class="stat-percentage" id="generalStats_emailClickedLinkPercentage">-</div>
                        <div class="stat-description">Mail link clicked</div>
                    </div>
                </div>
                <div class="stat-box red">
                    <img src="../assets/images/stats/form_submit.png" alt="Form submit icon">
                    <div>
                        <div class="stat-percentage" id="generalStats_formSubmittedPercentage">-</div>
                        <div class="stat-description">Form submitted</div>
                    </div>
                </div>
                <div class="stat-box green">
                    <img src="../assets/images/stats/reported2.png" alt="Mail reported icon">
                    <div>
                        <div class="stat-percentage" id="generalStats_emailReportedPercentage">-</div>
                        <div class="stat-description">Mail reported</div>
                    </div>
                </div>
                <div class="stat-box blue">
                    <img src="../assets/images/stats/clock.png" alt="Campaign duration">
                    <div>
                        <div class="stat-percentage" id="generalStats_campaignDuration">-</div>
                        <div class="stat-description">Campaign duration</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="container-device-stats">
                <div class="stats-title">Device type and system version</div>
                <div class="device">
                    <div class="device-type">
                        <img src="../assets/images/stats/desktop.png" alt="Desktop - Laptop PC">
                        <div class="stat-percentage" id="deviceStats_desktopPercentage">-</div>
                        <div class="stat-description">Desktop & Laptop</div>
                    </div>
                    <div class="system-version-container">
                        <div class="system-version">
                            <img src="../assets/images/stats/windows.png" alt="Windows">
                            <p id="deviceStats_win">-</p>
                            <p>Windows</p>
                        </div>
                        <div class="system-version">
                            <img src="../assets/images/stats/mac.png" alt="Mac OS">
                            <p id="deviceStats_mac">-</p>
                            <p>MacOS</p>
                        </div>
                        <div class="system-version">
                            <img src="../assets/images/stats/linux.png" alt="Linux">
                            <p id="deviceStats_linux">-</p>
                            <p>Linux</p>
                        </div>
                    </div>
                </div>
                <div class="device">
                    <div class="device-type">
                        <img src="../assets/images/stats/mobile.png" alt="Mobile phone">
                        <div class="stat-percentage" id="deviceStats_mobilePercentage">-</div>
                        <div class="stat-description">Mobile & Tablet</div>
                    </div>
                    <div class="system-version-container">
                        <div class="system-version">
                            <img src="../assets/images/stats/android.png" alt="Android">
                            <p id="deviceStats_android">-</p>
                            <p>Android</p>
                        </div>
                        <div class="system-version">
                            <img src="../assets/images/stats/ios.png" alt="iOS">
                            <p id="deviceStats_ios">-</p>
                            <p>iOS</p>
                        </div>
                        <div class="system-version">
                            <img src="../assets/images/stats/other.png" alt="Other">
                            <p id="deviceStats_other">-</p>
                            <p>Other</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="container-general-stats">
                <div class="stats-title">Template stats</div>
                <table class="styled-table">
                    <thead>
                        <tr>
                            <th>Template name</th>
                            <th>#Sent</th>
                            <th>#Clicked</th>
                            <th>#Submitted</th>
                            <th>#Reported</th>
                        </tr>
                    </thead>
                    <tbody id="templateStatsTable">
                        <tr>
                            <td colspan=5>No data to show</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row" v-if="this.user.role != 'Reader'">
            <h2>Details</h2>
            <table id="resultsTable" class="table">
                <thead>
                    <tr>
                        <th>Result ID</th>
                        <th class="no-sort"></th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Position</th>
                        <th>Status</th>
                        <th class="text-center">Reported</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
    <div id="no-campaign-found" class="row"></div>
</div>

</template>
  
  <script>
  export default {
    name: 'CampaignResultsComponent',
    //props: {
    //  msg: String
    //}
    mounted() {

        let customScript = document.createElement('script')

        customScript.setAttribute('src', '/scripts/campaign_results.js')

        customScript.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript)

        let customScript2 = document.createElement('script')

        customScript2.setAttribute('src', '/scripts/utils.js')

        customScript2.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript2)

    },
    methods: {
        getUserFromSession() {
            this.utente = window.sessionStorage.getItem('user');
        }
    },
    beforeMount() {
        this.user = window.sessionStorage.getItem("user");
        this.user = JSON.parse(this.user);
        if (null != this.user) {
            this.username = this.user.username;
        }
        this.getUserFromSession()


    },
  }
  </script>
  
  <style>
  
  </style>
  